export const GET_INSTAGRAM = "GET_INSTAGRAM";
export const GET_INSTAGRAM_SUCCESS = "GET_INSTAGRAM_SUCCESS";
export const GET_INSTAGRAM_FAIL = "GET_INSTAGRAM_FAIL";

export const ADD_INSTAGRAM_SUCCESS = "ADD_INSTAGRAM_SUCCESS";
export const ADD_INSTAGRAM_FAIL = "ADD_INSTAGRAM_FAIL";
export const UPDATE_INSTAGRAM_SUCCESS = "UPDATE_INSTAGRAM_SUCCESS";
export const DELETE_INSTAGRAM_SUCCESS = "DELETE_INSTAGRAM_SUCCESS";
